import { createElement, listen, replaceChildren, toText } from './dom.js';

const QUICK_ACTIONS = [
  ['missing', '检查还有哪些内容未纳入成果'],
  ['export', '说明三种导出格式的差异'],
  ['order', '检查章节顺序是否完整']
];

function message(role, text, citation = '') {
  const avatar = role === 'user' ? '你' : 'AI';
  const bubble = createElement('div', {}, [createElement('p', { text })]);
  if (citation) {
    bubble.append(createElement('div', { className: 'assistant-citations' }, [
      createElement('span', { text: citation })
    ]));
  }
  return createElement('div', {
    className: `assistant-message${role === 'user' ? ' user-message' : ''}`
  }, [
    createElement('span', { className: 'assistant-avatar', text: avatar }),
    bubble
  ]);
}

function staticAnswer(key, state) {
  const chapters = state.document.chapters || [];
  const allItems = chapters.flatMap(chapter => chapter.items || []);
  const selectedChapters = chapters.filter(chapter => chapter.selected);
  const effectiveItems = selectedChapters.flatMap(chapter =>
    (chapter.items || []).filter(item => item.selected)
  );
  if (key === 'missing') {
    const omittedChapters = chapters.filter(chapter => !chapter.selected).length;
    const omittedItems = allItems.length - effectiveItems.length;
    if (!omittedChapters && !omittedItems) {
      return '当前所有有内容的章节和成果项都已纳入。导出前仍会检查图片文件是否可读取。';
    }
    return `当前有 ${omittedChapters} 个章节未选择，另有 ${omittedItems} 个成果项未进入有效导出范围。你可以在章节卡片中逐项复核。`;
  }
  if (key === 'export') {
    return 'PPTX 适合可编辑汇报，PDF 适合发送与归档，DOCX 适合完整文字和表格报告。三种格式共享同一份当前编排快照。';
  }
  if (key === 'order') {
    const first = toText(chapters[0]?.title, '暂无章节');
    const last = toText(chapters.at(-1)?.title, '暂无章节');
    return `当前共 ${chapters.length} 章，已选择 ${selectedChapters.length} 章。目录从“${first}”开始，以“${last}”结束，可用章节卡片右上角按钮调整顺序。`;
  }
  return `当前已选择 ${selectedChapters.length} 个章节、${effectiveItems.length} 项成果。06 只解释和编排已有数据，不会重新生成或改写上游内容。`;
}

function classifyQuestion(question) {
  if (/导出|PPT|PDF|Word|DOCX/i.test(question)) return 'export';
  if (/顺序|章节|目录|排序/.test(question)) return 'order';
  if (/遗漏|缺少|未纳入|没选|检查/.test(question)) return 'missing';
  return 'summary';
}

export function createStaticAssistant({ content, input, sendButton, getState }) {
  const removers = [];
  replaceChildren(content, [
    message('assistant', '我会解释当前编排状态与导出检查结果。06 只读取已保存内容，不会再次生成或改写方案。', '只读项目快照'),
    createElement('div', { className: 'quick-title', text: '快捷操作' }),
    ...QUICK_ACTIONS.map(([key, label]) => createElement('button', {
      className: 'quick-action',
      text: label,
      attrs: { type: 'button' },
      dataset: { assistantPrompt: key }
    }))
  ]);

  function ask(question, key = '') {
    const normalized = toText(question);
    if (!normalized) return;
    content.append(message('user', normalized));
    const answerKey = key || classifyQuestion(normalized);
    content.append(message('assistant', staticAnswer(answerKey, getState()), '当前编排状态'));
    content.scrollTop = content.scrollHeight;
  }

  removers.push(listen(content, 'click', event => {
    const target = event.target instanceof Element
      ? event.target.closest('[data-assistant-prompt]')
      : null;
    if (!target) return;
    ask(target.textContent, target.dataset.assistantPrompt);
  }));
  removers.push(listen(sendButton, 'click', () => {
    ask(input.value);
    input.value = '';
  }));
  removers.push(listen(input, 'keydown', event => {
    if (event.key !== 'Enter' || event.shiftKey) return;
    event.preventDefault();
    sendButton.click();
  }));

  return {
    ask,
    destroy() {
      removers.splice(0).forEach(remove => remove());
    }
  };
}
